import * as ra_language_pt_br from "ra-language-pt-br/src";

export const ra = {
  ...ra_language_pt_br.default.ra,
  auth: {
    ...ra_language_pt_br.default.ra.auth,
    email: "Email",
  },
  action: {
    ...ra_language_pt_br.default.ra.action,
    load_more: "Carregar mais",
    apply: "Aplicar",
    // Some custom UI pieces may reference this key (even though RA uses ra.message.loading)
    loading: "Carregando...",
    update_application: "Atualizar",
    send: "Enviar",
    next: "Próximo",
    back: "Voltar",
  },
  message: {
    ...ra_language_pt_br.default.ra.message,
    bulk_delete_content:
      "Você tem certeza que quer DELETAR PARA SEMPRE isso %{name}? |||| Você tem certeza que quer DELETAR PARA SEMPRE estes %{smart_count} items?",
    bulk_delete_title: "Deletar %{name} |||| Deletar %{smart_count} %{name}",
    delete_content: "Você tem certeza que deseja DELETAR PARA SEMPRE este registro?",
    delete_title: "Confirmação de exclusão de registro %{name}.",
    error: "Erro ao processar a requisição",
    http_error: "Erro de comunicação com o servidor",
    invalid_form: "Por favor, corrija os erros no formulário",
    loading: "Carregando...",
    no: "Não",
    not_found: "Página não encontrada",
    yes: "Sim",
  },
  notification: {
    ...ra_language_pt_br.default.ra.notification,
    updated: "Registro atualizado |||| %{smart_count} registros atualizados",
    created: "Registro criado",
    deleted: "Registro deletado! |||| %{smart_count} registros deletado!",
    bad_item: "Registro incorreto",
    item_doesnt_exist: "O registro não existe",
    http_error: "Erro de comunicação com o servidor",
    logged_out: "Sessão encerrada",
    not_authorized: "Você não tem permissão para acessar este recurso",
    application_update_available: "Uma nova versão da aplicação está disponível. Por favor, atualize.",
    "Failed to fetch": "Erro ao buscar dados. Verifique sua conexão com a internet e tente novamente mais tarde.",
  },
  page: {
    ...ra_language_pt_br.default.ra.page,
    edit: '%{name}: %{recordRepresentation}',
    show: '%{name}: %{recordRepresentation}',
    list: '%{name}',
    create: 'Criar %{name}',
    delete: 'Deletar %{name}',
    empty: 'Nenhum %{name} ainda.',
    invite: 'Você quer adicionar um?',
  }
};
